import { IonItem, IonLabel, IonSelect, IonSelectOption } from '@ionic/react'
import { useFormContext } from 'react-hook-form'

import { useTemplates } from '../../../hooks/templates/queries'
import { useReplacePlaceholders } from '../../../hooks/use-replace-placeholders'

import type { SelectChangeEventDetail } from '@ionic/react'
import type { UpdateBroadcastInputs } from '../broadcast.schema'

type Props = { disabled?: boolean }

function BroadcastTemplateSelect({ disabled }: Props) {
  const { setValue } = useFormContext<UpdateBroadcastInputs>()

  const templates = useTemplates()

  const { replacePlaceholders } = useReplacePlaceholders()

  function handleTemplateSelect(
    e: CustomEvent<SelectChangeEventDetail<string>>
  ) {
    const selectedTemplate = templates.data?.find(
      (template) => template.objectId === e.detail.value
    )
    if (!selectedTemplate) return

    setValue('smsTemplateId', selectedTemplate.smsTemplate?.objectId, {
      shouldDirty: true,
    })
    setValue('emailTemplateId', selectedTemplate.emailTemplate?.objectId, {
      shouldDirty: true,
    })
    setValue(
      'smsMessage',
      replacePlaceholders(selectedTemplate.smsTemplate?.body ?? ''),
      { shouldDirty: true }
    )
    setValue(
      'emailSubject',
      replacePlaceholders(selectedTemplate.emailTemplate?.subject ?? ''),
      { shouldDirty: true }
    )
    setValue(
      'emailMessage',
      replacePlaceholders(selectedTemplate.emailTemplate?.body ?? ''),
      { shouldDirty: true }
    )
    // TODO: HACK!!! SHOULD EVENTUALLY MOVE TO SAME STRUCTURE AS TEMPLATES WITH ATTACHMENTS ON EACH "TEMPLATE" TYPE
    setValue(
      'setAttachmentsSms',
      selectedTemplate.smsTemplate?.attachments
        ? [selectedTemplate.smsTemplate.attachments[0]]
        : null,
      { shouldDirty: true }
    )
    setValue(
      'setAttachmentsEmail',
      selectedTemplate.emailTemplate?.attachments
        ? [selectedTemplate.emailTemplate.attachments[0]]
        : null,
      { shouldDirty: true }
    )
  }

  return (
    <div className="py-2">
      <IonItem style={{ '--padding-start': 0 }}>
        <IonLabel>Select a Template</IonLabel>
        <IonSelect
          interfaceOptions={{ cssClass: 'dark-ionic-filter' }}
          onIonChange={handleTemplateSelect}
          okText="OK"
          cancelText="Dismiss"
          disabled={disabled}
          className="bg-transparent"
        >
          {templates.data?.map((template, index) => (
            <IonSelectOption key={index} value={template.objectId}>
              {template.name}
            </IonSelectOption>
          ))}
        </IonSelect>
      </IonItem>
    </div>
  )
}

export { BroadcastTemplateSelect }
